import { useSelector } from 'react-redux';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import {
  getFirstAppliedFilter,
  intervalSelector,
  realTimeModeOnTrendsSelector,
} from '@store/common/selectors';
import getQueryTag from '@utils/misc/queryTag';
import { tsQueryTemplate } from '../utils/metricCardsReqBodyTemplate';
import { queryMetricsAtom } from '../atoms';
import { isAppModule } from '@src/utils/constants';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';

function useTimeseriesQuery() {
  const interval = useSelector(intervalSelector);
  const appliedFilter = useSelector(getFirstAppliedFilter);
  const realTimeOnTrends = useSelector(realTimeModeOnTrendsSelector);
  const metrics = useAtomValue(queryMetricsAtom);
  const { dataScope, usecaseKey } = useSelector(activeDashboardSelector);

  // build timeseries query
  const query = useMemo(() => {
    const query = JSON.parse(JSON.stringify(tsQueryTemplate));
    const { rule: filter, _rKey = 0 } = appliedFilter;
    query.filter = filter;
    query.interval = `${interval.from}/${interval.to}`;
    query.granularity = interval.granularity;
    query.metrics = metrics;
    query.isLiveMode = realTimeOnTrends;
    // workaround to force refresh on KPI change
    query._rKey = _rKey;
    query.context = window.conviva.context;
    if (realTimeOnTrends && query.granularity !== 'ALL') {
      query.options.withTotals = false;
    }
    if (isAppModule) {
      query.options.dataScope = dataScope;
      query.options.presetKey = usecaseKey;
    }
    return query;
  }, [interval, appliedFilter, metrics, realTimeOnTrends, dataScope, usecaseKey]);

  const queryTag = getQueryTag({ liveMode: realTimeOnTrends });
  return { query, metrics, interval, realTimeOnTrends, queryTag, dataScope, usecaseKey };
}

export default useTimeseriesQuery;
